const integrations = [
  // Cloud Infrastructure (Group 4 - Analysis)
  {
    icon: "/inte/AWS.png",
    label: "AWS",
    href: "/identity-management/iam/aws",
    color: "#4285F4",
    category: "Cloud Infrastructure",
    isAvailable: true,
  },
  {
    icon: "/inte/Azure.png",
    label: "Azure",
    href: "/integration/iam/azure",
    color: "#0078D4",
    category: "Cloud Infrastructure",
    isAvailable: true,
  },
  {
    icon: "/inte/GCP.png",
    label: "GCP",
    href: "/integration/iam/gcp",
    color: "#4285F4",
    category: "Cloud Infrastructure",
    isAvailable: true,
  },
  {
    icon: "/inte/ElasticCloud.svg",
    label: "Elastic",
    href: "/integration/elastic",
    color: "#4285F4",
    category: "Cloud Infrastructure",
    isAvailable: true,
  },
  {
    icon: "/inte/OCI.jpeg",
    label: "OCI",
    href: "/integration/oci",
    color: "#F80000",
    category: "Cloud Infrastructure",
    isAvailable: false,
  },
  {
    icon: "/inte/K8s.png",
    label: "Kubernetes",
    href: "/integration/kubernetes",
    color: "#326CE5",
    category: "Cloud Infrastructure",
    isAvailable: false,
  },
  {
    icon: "/inte/ali.png",
    label: "Ali Cloud",
    href: "/integration/ali",
    color: "#326CE5",
    category: "Cloud Infrastructure",
    isAvailable: false,
  },

  // Storage (Group 3 - Storage, cloud storage & buckets)
  {
    icon: "/inte/AWSS3.svg",
    label: "S3",
    href: "/integration/s3",
    type: "s3",
    color: "#4285F4",
    category: "Storage",
    isAvailable: true,
  },
  {
    icon: "/inte/AzureBlockStorage.png",
    label: "Azure Blob",
    href: "/integration/azure-blob",
    color: "#0078D4",
    category: "Storage",
    isAvailable: true,
  },
  {
    icon: "/inte/GoogleCloudStorage.svg",
    label: "GCS",
    href: "/integration/gcs",
    color: "#4285F4",
    category: "Storage",
    isAvailable: true,
  },
  {
    icon: "/inte/9drive.png",
    label: "Google Drive",
    href: "/integration/gdrive",
    color: "#4285F4",
    category: "Storage",
    isAvailable: false,
  },
  {
    icon: "/inte/1drive.png",
    label: "OneDrive",
    href: "/integration/onedrive",
    color: "#0078D4",
    category: "Storage",
    isAvailable: false,
  },
  {
    icon: "/inte/Snowflake.png",
    label: "Snowflake",
    href: "/integration/snowflake",
    color: "#29B5E8",
    category: "Storage",
    isAvailable: false,
  },

  // Version Control System (Group 1 - Source Control)
  {
    icon: "/github.png",
    label: "GitHub",
    href: "/integration/github",
    type: "github",
    color: "#24292E",
    category: "Version Control System",
    isAvailable: true,
  },
  {
    icon: "/gitlab.svg",
    label: "GitLab",
    href: "/integration/gitlab",
    type: "gitlab",
    color: "#FC6D26",
    category: "Version Control System",
    isAvailable: true,
  },
  {
    icon: "/bitbucket.png",
    label: "Bitbucket",
    href: "/integration/bitbucket",
    type: "bitbucket",
    color: "#0052CC",
    category: "Version Control System",
    isAvailable: true,
  },
  {
    icon: "/inte/AzureRepo.png",
    label: "Azure Repos",
    href: "/integration/azure-repos",
    color: "#0078D4",
    category: "Version Control System",
    isAvailable: false,
  },
  {
    icon: "/inte/ghe.jpeg",
    label: "GitHub Enterprise",
    href: "/integration/github-enterprise",
    color: "#24292E",
    category: "Version Control System",
    isAvailable: false,
  },
  {
    icon: "/inte/gitea.png",
    label: "Gitea",
    href: "/integration/gitea",
    color: "#24292E",
    category: "Version Control System",
    isAvailable: false,
  },

  // Messaging Services (Group 5)
  {
    icon: "/intelIcons/Slack.png",
    label: "Slack",
    href: "/integration/slack",
    color: "#4A154B",
    category: "Messaging Services",
    isAvailable: true,
  },
  {
    icon: "/inte/teams.webp",
    label: "Teams",
    href: "/integration/teams",
    type: "teams",
    color: "#464EB8",
    category: "Messaging Services",
    isAvailable: true,
  },
  {
    icon: "/inte/webex.png",
    label: "Webex",
    href: "/integration/webex",
    color: "#00B2FF",
    category: "Messaging Services",
    isAvailable: false,
  },
  {
    icon: "/inte/GoogleChat.png",
    label: "Google Chat",
    href: "/integration/google-chat",
    color: "#00AC47",
    category: "Messaging Services",
    isAvailable: false,
  },

  // Service Accounts (Group 2)
  {
    icon: "/inte/GoogleWorkspace.png",
    label: "Google Workspace",
    href: "/integration/google-workspace",
    color: "#4285F4",
    category: "Service Accounts",
    isAvailable: false,
  },
  {
    icon: "/inte/ActiveDirectory.png",
    label: "Active Directory",
    href: "/integration/active-directory",
    color: "#0078D4",
    category: "Service Accounts",
    isAvailable: true,
  },
  {
    icon: "/inte/EntraID.png",
    label: "Entra ID",
    href: "/integration/entra-id",
    color: "#0078D4",
    category: "Service Accounts",
    isAvailable: false,
  },
  {
    icon: "/inte/Okta.png",
    label: "Okta",
    href: "/integration/okta",
    color: "#007DC1",
    category: "Service Accounts",
    isAvailable: false,
  },

  // Tools & CI/CD Pipelines (Group 6 - DevOps Pipelines)
  {
    icon: "/inte/Jenkins.png",
    label: "Jenkins",
    href: "/integration/jenkins",
    color: "#D24939",
    category: "Tools & CI/CD Pipelines",
    isAvailable: false,
  },
  {
    icon: "https://circleci.com/favicon.ico",
    label: "CircleCI",
    href: "/integration/circleci",
    color: "#343434",
    category: "Tools & CI/CD Pipelines",
    isAvailable: false,
  },
  {
    icon: "/inte/Github.png",
    label: "GitHub Actions",
    href: "/integration/github-actions",
    color: "#2088FF",
    category: "Tools & CI/CD Pipelines",
    isAvailable: false,
  },
  {
    icon: "/inte/TravisCI.svg",
    label: "Travis CI",
    href: "/integration/travis-ci",
    color: "#3EAAAF",
    category: "Tools & CI/CD Pipelines",
    isAvailable: false,
  },
  {
    icon: "/inte/AzureDevOps.png",
    label: "Azure DevOps",
    href: "/integration/azure-devops",
    color: "#0078D4",
    category: "Tools & CI/CD Pipelines",
    isAvailable: false,
  },
  {
    icon: "/inte/GitLabCI.png",
    label: "GitLab CI",
    href: "/integration/gitlab-ci",
    color: "#FC6D26",
    category: "Tools & CI/CD Pipelines",
    isAvailable: false,
  },
  {
    icon: "/intelIcons/Bitbucket.png",
    label: "Bitbucket Pipelines",
    href: "/integration/bitbucket-pipelines",
    color: "#0052CC",
    category: "Tools & CI/CD Pipelines",
    isAvailable: false,
  },

  // Container Registries (Group 7)
  {
    icon: "/inte/ecr.png",
    label: "ECR",
    href: "/integration/gcr",
    color: "#4285F4",
    category: "Container Registries",
    isAvailable: false,
  },
  {
    icon: "/inte/AzureCR.png",
    label: "ACR",
    href: "/integration/azure-cr",
    color: "#0078D4",
    category: "Container Registries",
    isAvailable: false,
  },
  {
    icon: "/intelIcons/DockerHub.png",
    label: "Docker Hub",
    href: "/integration/docker-hub",
    color: "#2496ED",
    category: "Container Registries",
    isAvailable: false,
  },
  {
    icon: "/inte/gcr.png",
    label: "GCR",
    href: "/integration/elastic-container-registry",
    color: "#4285F4",
    category: "Container Registries",
    isAvailable: false,
  },
  {
    icon: "/inte/JFrog.png",
    label: "JFrog",
    href: "/integration/jfrog",
    color: "#41BF47",
    category: "Container Registries",
    isAvailable: false,
  },

  // SaaS Applications (Group 8 - Other SaaS)
  {
    icon: "/intelIcons/Postman.png",
    label: "Postman",
    href: "/integration/postman",
    color: "#FF6C37",
    category: "SaaS Applications",
    isAvailable: false,
  },
  {
    icon: "/intelIcons/HuggingFace.png",
    label: "Hugging Face",
    href: "/integration/huggingface",
    color: "#FF6B35",
    category: "SaaS Applications",
    isAvailable: true,
  },
];

export default integrations;
